module.exports = __webpack_public_path__ + "static/media/phone.cee4ba08.svg";